<template>
  <div id="app">
    <!-- <headers></headers> -->
    <!-- <keep-alive> -->
    <router-view></router-view>
    <!-- </keep-alive> -->
    <!-- <footers></footers> -->
  </div>
</template>

<script>
import headers from './components/header/header';
import footers from "./components/foot/footer.vue";

export default {
  components: {
    headers: headers,
    footers: footers
  },
  data() {
    return {}
  },
  methods: {
    config(type) {
      var api = this.$api.api.demo.config;
      this.$https.post({
        api: api,
        type: "formData",
      }, {}, (response) => {
        console.log(2)
        this.$store.commit('user/common', response.data)
      }, (error) => {
        console.log(error);
      });
    },
  },
  created: function () {
    this.config()
    console.log("url--info", this.$route.path);

  }
}
</script>

<style lang="scss">
.detail-tabs .el-tabs__header {
  display: none;
}
</style>




// WEBPACK FOOTER //
// App.vue?6abfaf07